import React from 'react';
import '../less/vacanciesList.less';
import { DropDown } from "MWC";
import Pagination from "MWComponents/dest/components/Pagination";
import CustomDropdown from "../../../auxiliary-components/shared/CustomDropdown";
import arrow_back_icon from "../img/arrow_back_icon.svg";
import { LANG } from "../../../services/l10n";
import Preloader from "MWComponents/dest/components/Preloader";
import Checkbox from "MWComponents/dest/components/Checkbox";
import { plural } from "utils/plural";

export default function template() {
  const isMobile = this.isViewportMobile(),
    isTablet = this.isViewportTablet(),
    {
      vacancies,
      total
    } = this.state,
    {
      departmentsUA,
      departmentsRU,
      citiesUA,
      citiesRU,
      workTypesUA,
      workTypesRU,
    } = this.props.state,
    isUa = this.props.lang === LANG.UA,
      phraseArray = ['VACANCIES_RIGHT_SIDE_COUNT_1', 'VACANCIES_RIGHT_SIDE_COUNT_234','VACANCIES_RIGHT_SIDE_COUNT'],
    positions = vacancies.length ? vacancies.map((elem, index) => {
      const cityName = isUa ? 'name_ua' : 'name_ru',
        department = isUa ? elem.department.name_ua : elem.department.name_ru,
        workType = isUa ? elem.work_type.name_ua : elem.work_type.name_ru,
        name = isUa ? elem.name_ua : elem.name_ru,
        salary = isUa ? elem.salary : elem.salary,
        experience = isUa ? elem.experience_work_ua : elem.experience_work_ru,
        short_desc = elem.short_desc;
      return(
        <div key={index} className="right-side-list-wrap">
          <div className="right-side-list-wrap-item">
            <div  className="right-side-list-wrap-item-tags">
              {elem.city.map((cities, i) => (
              <div key={`some2_${i}`} className="right-side-list-wrap-item-tags-item">
                   {cities.tags[0][cityName]}
              </div>
              ))}
              <div  className="right-side-list-wrap-item-tags-item"
                    dangerouslySetInnerHTML={{__html: department}}>
              </div>
              <div className="right-side-list-wrap-item-tags-item"
                    dangerouslySetInnerHTML={{__html: workType}}>
              </div>
            </div>
            <div className="right-side-list-wrap-item-title" onClick={(e) => this.context.app.navigate(`vacancies-list/${elem.id}`, e)}>
              {name}
            </div>
            <div className="right-side-list-wrap-item-salary">
                {salary}
            </div>
            <div className="right-side-list-wrap-item-exp">
              {experience}
            </div>
            <div className="right-side-list-wrap-item-short-decs">
              {short_desc}
            </div>
            <a className="right-side-list-wrap-item-more" onClick={(e) => this.context.app.navigate(`vacancies-list/${elem.id}`, e)} target="_self" href={`vacancies-list/${elem.id}`}>
              {this.l10n('VACANCIES_RIGHT_SIDE_MORE')}
            </a>
          </div>
        </div>
      )
  }) : '',
    filters = isMobile || isTablet ?
      (<div className="left-side" onClick={(e) => this.toggleFilter(e)}>
        <CustomDropdown title={!this.state.isShowFilter ? this.l10n("VACANCIES_LEFT_FILTERS_TITLE") : this.l10n("VACANCIES_LEFT_FILTERS_HIDE_TITLE")}>
          <div className="filters">
            <input onChange={this.changeFilter} name="name" type="text" className="filters-item search" placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_SEARCH')}>
            </input>
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_DEPARTMENT')}
              name="department"
              className="filters-item department"
              onChange={this.changeFilter}
              value={this.model.getParam('department')}
              collection={isUa ? departmentsUA : departmentsRU}
            />
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_CITY')}
              name="city"
              className="filters-item city"
              onChange={this.changeFilter}
              value={this.model.getParam('city')}
              collection={isUa ? citiesUA : citiesRU}
            />
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_FORMAT')}
              name="workType"
              className="filters-item format"
              onChange={this.changeFilter}
              value={this.model.getParam('workType')}
              collection={isUa ? workTypesUA : workTypesRU}
            />
            <Checkbox label={this.l10n('CAREER_HOT')} className="filters-checkbox hot" name="hot" onChange={this.changeFilter} checked={this.model.getParam('hot')}></Checkbox>
            <span className="clear" onClick={this.clearFilters}>{this.l10n('VACANCIES_LEFT_SIDE_FILTERS_CLEAR')}</span>
          </div>
        </CustomDropdown>
        <div className="module-content-wrapper">
          <div className="btn-back" onClick={(e) => this.context.app.navigate('/career', e)}> <img src={arrow_back_icon} alt='back'></img> {this.l10n('VACANCIES_LEFT_SIDE_BTN_BACK')}</div>
        </div>
      </div>)
      :
      (<div className="left-side">
          <div className="btn-back" onClick={(e) => this.context.app.navigate('/career', e)}>
            <img src={arrow_back_icon} alt='back'></img> {this.l10n('VACANCIES_LEFT_SIDE_BTN_BACK')}
          </div>
          <div className="filters">
            <input value={this.model.getParam('name')} onChange={this.changeFilter} name="name" type="text" className="filters-item search" placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_SEARCH')}>
            </input>
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_DEPARTMENT')}
              name="department"
              className="filters-item department"
              onChange={this.changeFilter}
              value={this.model.getParam('department')}
              collection={isUa ? departmentsUA : departmentsRU}
            />
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_CITY')}
              name="city"
              className="filters-item city"
              onChange={this.changeFilter}
              value={this.model.getParam('city')}
              collection={isUa ? citiesUA : citiesRU}
            />
            <DropDown
              placeholder={this.l10n('VACANCIES_LEFT_SIDE_FILTERS_FORMAT')}
              name="workType"
              className="filters-item format"
              onChange={this.changeFilter}
              value={this.model.getParam('workType')}
              collection={isUa ? workTypesUA : workTypesRU}
            />
            <Checkbox label={this.l10n('CAREER_HOT')} className="filters-checkbox hot" name="hot" onChange={this.changeFilter} checked={this.model.getParam('hot')}></Checkbox>
            <span className="clear" onClick={this.clearFilters}>{this.l10n('VACANCIES_LEFT_SIDE_FILTERS_CLEAR')}</span>
          </div>
      </div>),
      preload = this.state.preload ?
        (<div className="preload-wrapper">
          <Preloader />
        </div>) : '';
  return (
      <div className="module-vacancies-list-container">
        {isMobile || isTablet ? filters : ''}
        <div className="module-content-wrapper">
          {isMobile || isTablet ? '' : filters}
          <div className="right-side">
            <div className="right-side-header">
              <div className="right-side-header-title">{this.l10n('VACANCIES_RIGHT_SIDE_TITLE')}</div>
              <div className="right-side-header-count">{(total || '0') + this.l10n(`${plural(total, phraseArray )}`)}</div>
            </div>
            <div className="right-side-list">
              {positions}
              {preload}
            </div>
            <div className="paginator-wrapper">
              {(this.state.totalPages && this.state.totalPages !== 1) ?
                <Pagination
                  totalPages={this.state.totalPages}
                  onChange={this.selectPage}
                  page={this.state.page}
                  visiblePages={this.state.visiblePages}
                  incrementButton={this.state.page !== this.state.totalPages}
                  decrementButton={this.state.page !== 1}
                ></Pagination>
                :
                ''
              }
            </div>
          </div>
        </div>
      </div>
  );
}
